module.exports = __webpack_public_path__ + "media/images/icon__nativeAppShare@2x-a4b2d14e19927f09507d86378e0ea83e.png";